import { Box, CircularProgress, Modal } from "@mui/material";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import React from "react";
import TransportDriverInfo from "./TransportDriverInfo";
import TransportDriverService from "services/TransportDriverService";
import { useParams } from "react-router-dom";

type props = {
  handleClose: () => void;
};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1200,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "10px",
};

export const PersonalDataModal: React.FC<props> = ({ handleClose }) => {
  const { driverId } = useParams<{ driverId: string }>();
  const { data } = TransportDriverService.useGetTransportDriverQuery(Number(driverId));

  return (
    <Modal open={true} onClose={handleClose}>
      <Box sx={style}>
        {data ? (
          <TransportDriverInfo transportDriver={data} />
        ) : (
          <Box sx={{ flex: 1, padding: 2, display: "flex", justifyContent: "center", alignItems: "center" }}>
            <CircularProgress />
          </Box>
        )}
      </Box>
    </Modal>
  );
};
